import { Evt } from 'evt';

export const visitSpaceSectionEvt = new Evt<{
  sectionId: string;
}>();
